import React, { useState, useEffect, useRef } from 'react'
import profile from './assets/about-card-img.png';
import './css/Header.css';
import resume from './assets/files/resume.pdf';
const Header = () => {
    const [date, setDate] = useState(new Date().toTimeString());
    const [hello, setHello] = useState('01001000 01000101 01001100 01001100 01001111');
    const helloArray = [
        '01001000 01000101 01001100 01001100 01001111',
        'नमस्ते', 'ਸਤਿ ਸ਼੍ਰੀ ਅਕਾਲ', 'आदाब', 'प्रणाम',
        'வணக்கம்', 'నమస్కరం', 'Hola', 'Bonjour', 'Hallo',
        'Nǐ hǎo', 'S̄wạs̄dī', 'Ciao', 'Kon\'nichiwa', 'geia', 'Hi',
        '01001000 01000101 01001100 01001100 01001111', 'Grüß Gott'
    ];

    const [activeQuestion, setActiveQuestion] = useState(0);
    const containerRef = useRef(null);
    const questions = [
        "Is performance becoming a bottleneck as your application grows?",
        "Do you want modular, maintainable UI instead of fragile components?",
        "Are you planning features that demand real-time interaction?",
        "Looking for someone who thinks in systems — not just screens?",
        "Want an engineer who takes ownership from idea to production?"
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setDate(getRealTime());
            setHello(helloArray[randomInteger(0, 16)]);
        }, 2000);
        const handleScroll = () => {
            if (!containerRef.current) return;
            const midPoint = window.innerHeight / 2;
            const els = containerRef.current.querySelectorAll('p');
            let closestIndex = 0, minDistance = Infinity;
            els.forEach((el, i) => {
                const rect = el.getBoundingClientRect();
                const d = Math.abs(rect.top + rect.height / 2 - midPoint);
                if (d < minDistance) { minDistance = d; closestIndex = i; }
            });
            setActiveQuestion(closestIndex);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => { clearInterval(timer); window.removeEventListener('scroll', handleScroll); };
    }, []);

    function randomInteger(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
    function getRealTime() { return new Date().toTimeString(); }

    const leftRows = [
        { k: 'SESSION', v: 'ACTIVE', hot: true },
        { k: 'ROLE', v: 'SR. ENGINEER', hot: false },
        { k: 'STACK', v: 'React / TS', hot: false },
        { k: 'LATENCY', v: '12ms', hot: true },
        { k: 'UPTIME', v: '99.98%', hot: true },
        { k: 'LOCATION', v: 'New Delhi, IN', hot: false },
    ];

    const leftLog = [
        '> init_session()',
        '  loading profile...',
        '> auth verified ✓',
        '  scanning env...',
        '> ready',
    ];

    const rightRows = [
        { k: 'NODE', v: 'v20.11.0', hot: false },
        { k: 'BUILD', v: 'PASSING', hot: true },
        { k: 'COVERAGE', v: '94%', hot: true },
        { k: 'DEPLOY', v: 'PRODUCTION', hot: true },
        { k: 'ENV', v: 'STABLE', hot: true },
        { k: 'ERRORS', v: '0', hot: false },
    ];

    const rightLog = [
        '> npm run build',
        '  bundle: 142kb',
        '> lighthouse 91',
        '  perf: optimal',
        '> all checks pass',
    ];

    return (
        <>


            <div className='questions' ref={containerRef}>
                {questions.map((q, i) => (
                    <p key={i} className={i === activeQuestion ? 'highlight' : ''}>{q}</p>
                ))}
            </div>

            <div className="d-flex about">
                <div className="about-inner">

                    {/* ── LEFT panel ── */}
                    <div className="side-panel side-panel--left">
                        <div className="sp-header">
                            <span className="sp-label">SYS_MONITOR</span>
                            <span className="sp-dot" />
                        </div>
                        <div className="sp-divider" />
                        <div className="sp-rows">
                            {leftRows.map((r, i) => (
                                <div key={i} className="sp-row" style={{ animationDelay: `${i * 0.12}s` }}>
                                    <span className="sp-key">{r.k}</span>
                                    <span className={`sp-val ${r.hot ? 'sp-val--hot' : 'sp-val--dim'}`}>{r.v}</span>
                                </div>
                            ))}
                        </div>
                        <div className="sp-divider" />
                        <div className="sp-log">
                            {leftLog.map((line, i) => (
                                <p key={i} className="sp-log-line" style={{ animationDelay: `${0.8 + i * 0.5}s` }}>{line}</p>
                            ))}
                        </div>
                    </div>

                    {/* ── Card — completely unchanged ── */}
                    <div className="aboutText">
                        <div className='topbar'>
                            <div className='options'>
                                <span></span><span></span><span></span>
                            </div>
                            <a
                                className="card-linkedin"
                                href="https://www.linkedin.com/in/shruti-sharma-dev"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                            >
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
                            </a>
                        </div>
                        <h6 className='date-time'>{date}</h6>
                        <img
                            src={profile}
                            className="header-img"
                            alt="Shruti Sharma"
                            style={{ opacity: 'var(--scroll-transition)' }}
                        />
                        <div className='text'>
                            <span>{hello}</span> I'm <b>Shruti Sharma</b> I'm a Software Engineer.
                        </div>
                        <div className='btm-txt'>
                            Last login: <span>Sun Mar  3 19:06:59 on console</span> <br />
                            google-cloud-cli <span>437.0.1-darwin-arm.tar.gz</span> <br />
                        </div>

                        {/* ── CTA buttons ── */}
                        <div className="header-cta">
                            <button
                                className="cta-btn"
                                onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
                            >
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
                                Projects
                            </button>
                            <button
                                className="cta-btn"
                                onClick={() => document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' })}
                            >
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /></svg>
                                Experience
                            </button>
                            {/* <a
                                className="cta-btn"
                                href={resume}
                                download={resume}
                            >
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
                                Download CV
                            </a> */}
                        </div>
                    </div>

                    {/* ── RIGHT panel ── */}
                    <div className="side-panel side-panel--right">
                        <div className="sp-header">
                            <span className="sp-label">BUILD_STATUS</span>
                            <span className="sp-dot" style={{ animationDelay: '1s' }} />
                        </div>
                        <div className="sp-divider" />
                        <div className="sp-rows">
                            {rightRows.map((r, i) => (
                                <div key={i} className="sp-row" style={{ animationDelay: `${i * 0.12}s` }}>
                                    <span className="sp-key">{r.k}</span>
                                    <span className={`sp-val ${r.hot ? 'sp-val--hot' : 'sp-val--dim'}`}>{r.v}</span>
                                </div>
                            ))}
                        </div>
                        <div className="sp-divider" />
                        <div className="sp-log">
                            {rightLog.map((line, i) => (
                                <p key={i} className="sp-log-line" style={{ animationDelay: `${0.8 + i * 0.5}s` }}>{line}</p>
                            ))}
                        </div>
                    </div>

                </div>

                <div className="desc">
                    <p>I build scalable, high-performance software with a focus on clean architecture, modular design, and maintainability. With 4 years of professional experience, I specialize in Angular, React, TypeScript, and Node.js, with hands-on experience in GraphQL, SQL, RxJS, SSR, Micro Frontends, and performance optimization. I've worked on production platforms serving 25M+ users and built projects spanning AI-powered applications and distributed systems. Currently, I'm expanding my AI and backend engineering skills with Python and LangChain. As an incoming M.Sc. Interactive Media student at FH Upper Austria, I'm looking for Werkstudent opportunities in Software Engineering, AI, and digitalization in Austria from October 2026.</p>
                </div>
            </div>
        </>
    );
}

export default Header;